import { useAuthentication } from '../contexts/AuthContext';
import PermissionService from '../services/PermissionService';
import { IMenuItems } from '../services/PermissionService/types';
import { useCallbackWithLoading } from './useCallbackWithLoading';

interface IUsePermission {
  getMenuItems: () => Promise<IMenuItems[]>;
  updateAdminPermission: (payload: any) => Promise<any>;
}

export const usePermission = (): IUsePermission => {
  const { sessionToken } = useAuthentication();
  const getMenuItems = useCallbackWithLoading(async () => {
    const menuItems = await PermissionService.getMenuItems(sessionToken?.rawValue);
    return menuItems;
  }, [sessionToken?.rawValue]);

const updateAdminPermission = useCallbackWithLoading(async (payload) => {
    const user = await PermissionService.updateAdminPermission(payload, sessionToken?.rawValue);
    return user;
}, [sessionToken?.rawValue]);

  return {
    getMenuItems,
    updateAdminPermission,
  };
};
